// category-toggler


$(document).on("click", ".category-toggler", function (e) {
    e.preventDefault();
    $("body").toggleClass("open-menu");


  });

  var MLHelper = window.SHTHelper || {};
  MLHelper.qs = document.querySelector.bind(document);
  MLHelper.qsa = document.querySelectorAll.bind(document);
  MLHelper.qid = document.getElementById.bind(document);
  MLHelper.qde = document.documentElement;



  class MLHLazyLoadingVideo extends HTMLElement {
    constructor() {
      super(),
        (this.iframe = this.querySelector("iframe")),
        (this.template = this.querySelector("template")),
        (this.isMouseenter = !1);
    }
    loadVideo() {
      var t;
      this.iframe &&
        (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
        this.iframe.addEventListener(
          "load",
          function () {
            "youtube" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              ),
              "vimeo" == this.dataVideoType &&
                this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }.bind(this)
        )),
        "local_video" == this.dataVideoType &&
          ((this.local_video = this.querySelector("video")),
          (t = this.local_video.querySelector("source").getAttribute("data-src")),
          (this.local_video.src = t));
    }
    execute() {
      Shopify.designMode
        ? this.loadVideo()
        : (["mousemove", "touchstart"].forEach(
            function (t) {
              MLHelper.qs("body").addEventListener(
                t,
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              );
            }.bind(this)
          ),
          window.addEventListener(
            "scroll",
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          ));
    }
    static get observedAttributes() {
      return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(t) {
      this.setAttribute("data-video-type", t);
    }
    get dataVideoType() {
      return this.getAttribute("data-video-type");
    }
    set dataVideoId(t) {
      this.setAttribute("data-video-id", t);
    }
    get dataVideoId() {
      return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(t, e, s) {
      e !== s && this.execute();
    }
    connectedCallback() {
      this.execute();
    }
    disconnectedCallback() {}
  }
  customElements.define("mlh-load-video", MLHLazyLoadingVideo);




  class slideshowSwiper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sliderWrapper = this.querySelector(".slideshow__swiper");
  
      let centered_slides =
        this.sliderWrapper.dataset.centeredslides !== undefined
          ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
          : undefined;
      let effect_fade =
        this.sliderWrapper.dataset.effectfade !== undefined
          ? JSON.parse(this.sliderWrapper.dataset.effectfade)
          : undefined;
      let next = this.querySelector(".swiper-button-next");
      let prev = this.querySelector(".swiper-button-prev");
      let pagination = this.querySelector(".swiper-pagination");
  
      new Swiper(this.sliderWrapper, {
        effect: effect_fade ? "fade" : "slide",
        centeredSlides: centered_slides ? centered_slides : false,
        slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
        spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
        grabCursor: false,
        horizontal: true,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
        loop: JSON.parse(this.sliderWrapper.dataset.loop),
        speed: 700,
        mousewheel: {
          forceToAxis: true,
        },
        autoplay: {
          enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
          disableOnInteraction: false,
          delay: parseInt(this.sliderWrapper.dataset.delay),
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          359: {
            slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
          },
          768: {
            slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
            spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
          },
          1024: {
            slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
            spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
          },
        },
      });
    }
  }
  customElements.define("slideshow-swiper", slideshowSwiper);



  class productSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.product__swiper = this.querySelector(".product__swiper");
  
      let next = this.querySelector(".swiper-button-next");
      let prev = this.querySelector(".swiper-button-prev");

      new Swiper(this.product__swiper, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        speed: 700,
        navigation: {
          nextEl: next,
          prevEl: prev,
        }
      });
    }
  }
  customElements.define("product-slider", productSlider);




  